import { GalleryDto, GalleryPresetDto, StandardGalleryPresetDto } from '@nusign/picflow-backend-types';
import { arraysEqualNoOrder } from '../../lib/arrays-equal';
import { getPresetChanges } from '../../lib/new-gallery';
import { objectsMatch } from '../../lib/objects-match';

export const findPreset = (
  gallery: GalleryDto,
  standardPresets: StandardGalleryPresetDto[],
  customPresets: GalleryPresetDto[]
): StandardGalleryPresetDto | GalleryPresetDto => {
  return [...standardPresets, ...customPresets].find(preset => {
    if (!arraysEqualNoOrder(preset.enabled_feedback_options, gallery.enabled_feedback_options)) return false;
    const changes = getPresetChanges(preset);
    delete changes.enabled_feedback_options;

    const all = Object.keys(changes).every(key => {
      if (key === 'color_labels') {
        const test = arraysEqualNoOrder(
          gallery.color_labels.map(l => l.active + l.name + l.color),
          changes.color_labels.map(l => l.active + l.name + l.color)
        );
        return test;
      }

      if (
        gallery[key] !== null &&
        changes[key] !== null &&
        (typeof gallery[key] === 'object' || typeof changes[key] === 'object')
      ) {
        return objectsMatch(gallery[key], changes[key]);
      }

      return gallery[key] === changes[key];
    });
    return all;
  });
};
